// @flow
import React, { Component } from "react";

type PropsType = {
  translate: string => void
};
type StateType = {};

const testimonialData = [
  {
    text: "Yapı marketlerimizin sayımlarını kendi çalışanlarımızla Envanterium Sayım Teknolojilerini " +
      "kullanarak tamamladık. Kullanımı kolay arayüze sahip sayım programları ve hızlı raporlama sistemleri " +
      "sayesinde sayımlarımız oldukça rahat geçti.",
    name: "Timur Sevinç",
    date: "28.02.2018",
    company: "Neyzen Yapı Marketleri",
    title: "Bilgi İşlem ve Stok Müdürü"
  },
  {
    text: "Envanterium, sayım talebimize hızlı bir şekilde yanıt verip kısa bir sürede operasyonlarımızı " +
      "başarıyla sonuçlandırdı ve mağaza sayımlarımıza hızlı ve sağlıklı bir çözüm getirmiş oldu.",
    name: "Cenk Demirkol",
    date: "28.02.2018",
    company: "Demirkol / Arcade",
    title: "Genel Müdür"
  },
  {
    text: "Sürekli gelişen sayım teknolojilerinin yanı sıra genç ve dinamik ekibiyle Envanterium ile " +
      "gerçekleştirdiğimiz sayımlar oldukça verimli geçti.",
    name: "Mesut Şen",
    date: "18.09.2017",
    company: "Hacıbaba",
    title: "Koordinatör"
  },
  {
    text: "Envanterium, sağlam organizasyonları ve kaliteli ekibiyle depolarımızda çok iyi iş çıkardı. " +
      "İş birliğimizi sürdürüyor olmaktan memnuniyet duyarız.",
    name: "Necati Kosova",
    date: "17.09.2017",
    company: "Neko Otomotiv",
    title: "Yönetim Kurulu Başkanı"
  },
  {
    text: "Envanterium ile gerek kullandıkları teknoloji gerekse genç, dinamik ve tecrübeli ekibiyle " +
      "mağazalarımızda sorunsuz sayımlar geçirdik. Daha sonraki sayımlarımızda da birlikte çalışmaktan memnuniyet duyarız.",
    name: "Heval Börü Özarpat",
    date: "31.11.2017",
    company: "Maya Perakende Mağazacılık",
    title: "Genel Koordinatör"
  }
];

class TestimonialsUnit extends Component<PropsType, StateType> {
  testimonialCard = ({ text, name, date, company, title }: Object) => (
    <div className="col-md-4" key={`${date}-${company}-${name}`}>
      <div className="card shadow-3" style={{ height: "100%" }}>
        <div className="card-body px-6" style={{ display: "flex", flexDirection: "column" }}>
          <div className="rating mb-3">
            <label className="fas fa-star active"></label>
            <label className="fas fa-star active"></label>
            <label className="fas fa-star active"></label>
            <label className="fas fa-star active"></label>
            <label className="fas fa-star active"></label>
          </div>

          <p className="text-quoted mb-5" style={{ flexGrow: 1 }}>{text}</p>
          <div className="media align-items-center pb-0">
            <div className="media-body lh-1">
              <div className="fw-400 small-1 mb-1">{name} - {date}</div>
              <small className="text-lighter">{company} - {title}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const { translate } = this.props;
    return (
      <section className="section">
        <div className="container">
          <header className="section-header">
            <h2>{translate("LandingPageLocale.testimonials_unit.header.title")}</h2>
            <hr />
            <p className="lead">{translate("LandingPageLocale.testimonials_unit.header.content")}</p>
          </header>
          <div className="row gap-y">
            {
              testimonialData.map(testimonial => (this.testimonialCard(testimonial)))
            }
          </div>
        </div>
      </section>
    );
  }
}

export default TestimonialsUnit;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/LandingPage/TestimonialsUnit.js